import { FaRegSave, FaShare } from "react-icons/fa";
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, ContentState, convertFromHTML } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from 'draftjs-to-html';
import { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ModalWrapper } from "./styled"
import ShowToast from "utils/ShowToast";
import errorImg from 'assets/images/no-image-found.png'
import { newsSelector } from 'redux/selector'
import { newsActions } from "redux/slice/newsSlice";
import ButtonIcon from "components/ButtonIcon"
import Label from "components/Label";
import Input from "components/Input";
import ErrorMessage from "components/ErrorMessage";

const AdminEditNews = ({ selectedId, showModal, method, hidden, dataNewsCategory, currentPage, querySearch, selectedCategory, setCurrentPage }) => {
    const imageRef = useRef()
    const [dataCategory, setDataCategory] = useState([])
    const [category, setSelectedCategory] = useState(null)
    const newsState = useSelector(newsSelector)
    const dispatch = useDispatch()
    useEffect(() => {
        if (dataNewsCategory.length > 0 && method === 'add') {
            setDataCategory(dataNewsCategory)
            setSelectedCategory(dataNewsCategory[0].id)
        }
    }, [dataNewsCategory, showModal, selectedId, method])
    const [editorState, setEditorState] = useState(EditorState.createWithContent(
        ContentState.createFromBlockArray(
            convertFromHTML('<p></p>')
        )
    ));

    let title = ''
    switch (method) {
        case 'add':
            title = 'Thêm bài viết'
            break;
        case 'show':
            title = 'Chi tiết bài viết'
            break;
        case 'update':
            title = 'Cập nhật bài viết'
            break;
        case 'remove':
            title = 'Xóa bài viết'
            break;
        default:
            title = 'Thêm bài viết'
            break;
    }

    const formData = useFormik({
        initialValues: {
            id: "",
            title: "",
            thumbnail: "",
            description: "",
        },
        validateOnBlur: false,
        validateOnChange: false,
        validationSchema: Yup.object({
            title: Yup.string().required("Chưa nhập tên bài viết!"),
            description: Yup.string().required("Chưa nhập mô tả bài viết!"),
            thumbnail: Yup.string().required("Chưa nhập ảnh thumbnail"),
        }),
        onSubmit: (values, { setFieldError }) => {
            const payload = {
                news_category_id: category,
                title: values.title,
                thumbnail: values.thumbnail,
                description: values.description,
            }
            if (method === 'add') {
                const convert = draftToHtml(convertToRaw(editorState.getCurrentContent()))
                payload.content = convert
                dispatch(newsActions.addNews({ data: payload, ShowToast, currentPage, querySearch, selectedCategory, setFieldError, handleSetDefaultForm, hidden }))
            }
            if (method === 'update') {
                const convert = draftToHtml(convertToRaw(editorState.getCurrentContent()))
                payload.content = convert

                dispatch(newsActions.updateNews({ data: payload, id: values.id, ShowToast, currentPage, querySearch, selectedCategory, setFieldError, handleSetDefaultForm, hidden }))
            }
            if (method === 'remove') {

                dispatch(newsActions.removeNews({ id: values.id, ShowToast, currentPage, querySearch, selectedCategory }))
                handleSetDefaultForm()
                hidden()
            }
        }
    })

    useEffect(() => {
        if (selectedId !== null) {
            const data = newsState.newsList.filter(item => item.news_id === selectedId)
            formData.setValues({
                id: data[0].news_id,
                title: data[0].news_title,
                thumbnail: data[0].thumbnail,
                description: data[0].description,
            });
            setEditorState(data[0].content !== null
                ? EditorState.createWithContent(
                    ContentState.createFromBlockArray(
                        convertFromHTML(data[0].content)
                    )
                )
                : EditorState.createWithContent(
                    ContentState.createFromBlockArray(
                        convertFromHTML('<p></p>')
                    )
                )
            )
            if (dataNewsCategory.length > 0) {
                let newDataCategory = []
                dataNewsCategory.map(item => {
                    if (item.id !== data[0].id) {
                        newDataCategory.push(item)
                    }
                })
                dataNewsCategory.map(item => {
                    if (item.id === data[0].id) {
                        newDataCategory.unshift(item)
                    }
                })
                setSelectedCategory(newDataCategory[0].id)
                setDataCategory(newDataCategory)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedId, showModal, dataNewsCategory, newsState.newsList])
    function handleSetDefaultForm() {
        setEditorState(EditorState.createWithContent(
            ContentState.createFromBlockArray(
                convertFromHTML('<p></p>')
            )
        ))
        formData.setValues({
            id: "",
            title: "",
            thumbnail: "",
            description: "",
        })
        formData.setTouched({}, false);
        formData.setErrors({})
        setSelectedCategory(null)
    }
    const handleHiddenModal = () => {
        handleSetDefaultForm()

        hidden()
    }

    const handleErrorImage = () => {
        imageRef.current.src = errorImg
    }
    return (
        <ModalWrapper >
            <div className='aen_overlay'
                onClick={handleHiddenModal}
                style={
                    showModal ? {
                        transform: 'translateY(0%)',
                        opacity: 1
                    } : {
                        transform: 'translateY(-120%)',
                        opacity: 0
                    }
                }
            ></div>
            <div className='aen_container p-25'
                style={
                    showModal ? {
                        transform: 'translateY(0%)',
                        opacity: 1
                    } : {
                        transform: 'translateY(-120%)',
                        opacity: 0
                    }
                }
            >
                <form onSubmit={formData.handleSubmit}>
                    <h1 className='aen_header'>{title}</h1>
                    <ul className='aen_body'>
                        <li className='aen_item'>
                            <div className='aen_item_input'>
                                <div className="aen_item_image">
                                    <img
                                        ref={imageRef}
                                        src={formData.values.thumbnail || errorImg}
                                        alt="photos"
                                        onError={handleErrorImage}
                                    />
                                </div>
                                <Input
                                    id="aen_item_input_thumbnail"
                                    name="thumbnail"
                                    placeholder="Đường dẫn ảnh..."
                                    value={formData.values.thumbnail}
                                    onChange={formData.handleChange}
                                    onBlur={formData.handleBlur}
                                    isError={!!formData.errors.thumbnail}
                                    message={formData.errors.thumbnail}
                                    readOnly={(method === 'show' || method === 'remove') ? true : false}
                                />
                            </div>
                        </li>
                        {
                            method !== 'add' &&
                            <li className='aen_item'>
                                <div className='aen_item_input'>
                                    <Label className="mb-5">Mã bài viết:</Label>
                                    <Input
                                        id="aen_item_input_id"
                                        name="id"
                                        value={formData.values.id}
                                        readOnly={true}
                                    />
                                </div>
                            </li>
                        }
                        <li className='aen_item'>
                            <div className='aen_item_input'>
                                <label htmlFor='aen_item_input_category'>Loại bài viết:</label>
                                <select onChange={e => setSelectedCategory(e.target.value)} value={category ?? ""}
                                    disabled={(method === 'show' || method === 'remove') ? true : false}
                                >
                                    {
                                        dataCategory.map(item => (
                                            <option key={item.id} value={item.id}>{item.name}</option>
                                        ))
                                    }
                                </select>
                            </div>
                        </li>
                        <li className='aen_item'>
                            <div className='aen_item_input'>
                                <Label className="mb-5">Tên bài viết:</Label>
                                <Input
                                    id="aen_item_input_name"
                                    name="title"
                                    value={formData.values.title}
                                    onChange={formData.handleChange}
                                    onBlur={formData.handleBlur}
                                    readOnly={(method === 'show' || method === 'remove') ? true : false}
                                    isError={!!formData.errors.title}
                                    message={formData.errors.title}
                                />

                            </div>
                        </li>
                        <li className='aen_item'>
                            <div className='aen_item_input'>
                                <Label className="mb-5">Mô tả bài viết:</Label>
                                {
                                    formData.errors.description &&
                                    <ErrorMessage>{formData.errors.description}</ErrorMessage>
                                }
                                <textarea
                                    id="aen_item_input_name"
                                    name="description"
                                    value={formData.values.description}
                                    onChange={formData.handleChange}
                                    onBlur={formData.handleBlur}
                                    className={` ${formData.errors.description ? "bg-grey2 b-red-1" : "bg-white"}`}
                                    readOnly={(method === 'show' || method === 'remove') ? true : false}
                                ></textarea>
                            </div>
                        </li>
                        <li className='aen_item'>
                            <div className='aen_item_input'>
                                <label htmlFor='aen_item_input_name'>Nội dung:</label>
                                <div style={{ border: "1px solid #999", borderRadius: '4px', padding: '2px', minHeight: '550px', maxHeight: '550px' }}>
                                    <Editor
                                        editorState={editorState}
                                        onEditorStateChange={setEditorState}
                                        readOnly={(method === 'show' || method === 'remove') ? true : false}
                                    />
                                </div>
                            </div>
                        </li>
                    </ul>
                    <div className='aen_footer'>
                        {
                            method !== 'show' &&
                            <ButtonIcon
                                classButton="action-danger-1"
                                icon={<FaRegSave />}
                                isNa={newsState.isFetching}
                                type="submit"
                            >
                                {method === "add" ? "Thêm mới" : method === "update" ? "Cập nhật" : "Xóa"}
                            </ButtonIcon>

                        }
                        <ButtonIcon
                            classButton="action-primary ml-10"
                            icon={<FaShare />}
                            type="button"
                        >
                            Thoát
                        </ButtonIcon>

                    </div>
                </form>
            </div>
        </ModalWrapper>
    );
}

export default AdminEditNews;
